import { CSSProperties } from 'react';
import { twMerge } from 'tailwind-merge';

interface PlayerStylesOptions {
  width?: number | string;
  height?: number | string;
  aspectRatio: number;
  containerClassName?: string;
}

interface PlayerStyles {
  isResponsive: boolean;
  containerClasses: string;
  containerStyle: CSSProperties;
  videoClasses: string;
  videoStyle: CSSProperties;
}

/**
 * Computes container and video element styles based on sizing mode.
 * Supports both responsive (aspect-ratio based) and fixed (width/height) sizing.
 */
export const getPlayerStyles = ({
  width,
  height,
  aspectRatio,
  containerClassName
}: PlayerStylesOptions): PlayerStyles => {
  const isResponsive = !width && !height;

  const containerClasses = twMerge(
    containerClassName,
    'motto-video-container relative bg-[#111111]'
  );

  const containerStyle: CSSProperties = isResponsive
    ? { aspectRatio: aspectRatio.toString() }
    : { width, height };

  const videoClasses = isResponsive
    ? 'motto-video-responsive w-full'
    : 'w-full h-full';

  const videoStyle: CSSProperties = isResponsive
    ? {}
    : { width, height };

  return {
    isResponsive,
    containerClasses,
    containerStyle,
    videoClasses,
    videoStyle
  };
};
